import React from 'react';
import { WORDMARK } from '@/lib/brand';
import { LogoConcept } from '@/lib/logoConcepts';
import LogoMark from './LogoMark';

interface Props {
  /** 'dark' = for dark backgrounds (white text). 'light' = for light backgrounds. */
  tone?: 'light' | 'dark';
  size?: number;
  /** Pin a concept (brand studio previews). Defaults to the active mark. */
  concept?: LogoConcept;
  /** Hide the wordmark — app icon / compact placements. */
  markOnly?: boolean;
  className?: string;
}

/**
 * THE LOCKUP: symbol + GIGGONE wordmark.
 *
 * The wordmark itself comes from src/lib/brand.ts, so the all-caps brand
 * decision lives in exactly one place. The accent dot is the only piece of
 * typographic styling and it re-uses the brand orange, tying the wordmark back
 * to the symbol.
 */
const Logo: React.FC<Props> = ({
  tone = 'light',
  size = 36,
  concept,
  markOnly = false,
  className = '',
}) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <LogoMark concept={concept} variant="tile" size={size} className="rounded-[0.22em]" />
    {!markOnly && (
      <span
        className={`text-lg font-extrabold leading-none tracking-tight ${
          tone === 'dark' ? 'text-white' : 'text-slate-900'
        }`}
      >
        {WORDMARK.text}
        <span className="text-brand-orange">{WORDMARK.accent}</span>
      </span>
    )}
  </span>
);

export default Logo;
